jQuery(document).ready(function () {
    function adjustFlexSlider() {
        var windowWidth = window.innerWidth;
        var minItems, maxItems;

        minItems = 1;

        if (windowWidth < 850) { 
            maxItems = 1;
        } else if (windowWidth < 1025) {
            maxItems = 2;
        } else {
            maxItems = 3;
        }

        jQuery('#metaslider_900').flexslider({
            animation: "slide",
            slideshow: true,
            slideshowSpeed: 5000,
            directionNav: true,
            controlNav: false,
            pauseOnHover: true,
            itemWidth: 400,
            itemMargin: 0,
            minItems: minItems,
            maxItems: maxItems,
            touch: true,
            prevText: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.98 28.11"><defs><style>.cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:1.5px;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><line class="cls-1" x1="12.42" y1="0.49" x2="0.57" y2="14.19"/><line class="cls-1" x1="12.42" y1="27.62" x2="0.57" y2="13.92"/></g></g></svg>',
            nextText: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.98 28.11"><defs><style>.cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:1.5px;}</style></defs><g id="Capa_2" data-name="Capa 2"><g id="Layer_1" data-name="Layer 1"><line class="cls-1" x1="0.57" y1="27.62" x2="12.42" y2="13.92"/><line class="cls-1" x1="0.57" y1="0.49" x2="12.42" y2="14.19"/></g></g></svg>'
        });
    }

    adjustFlexSlider();

    window.addEventListener('resize', adjustFlexSlider);
});
